export enum UnemployedReason {
	NoExperience = 'NoExperience',
	Student = 'Student',
}
